import React, { useContext, useEffect, useState } from 'react';
import { CountryCode } from '@dayetopia/types';
import styled from 'styled-components';
import CartCrossSellRow from '@components/cart/CartCrossSellRow';
import CartSectionHeading from '@components/cart/CartSectionHeading';
import { Context } from '@components/Context';
import FadeIn from '@components/shared/FadeIn';
import { CartItem, ProductCode } from '@contracts';
import { filterProductsByCountry } from '@utils/product';

interface Props {
  maxItemsToShow?: number;
}

const CartCrossSells: React.FC<Props> = ({ maxItemsToShow = 2 }) => {
  const { state } = useContext(Context);
  const { cartItems, country } = state;
  const defaultProducts = [ProductCode.TamponTin, ProductCode.Proviotics];
  const [crossSellProducts, setCrossSellProducts] = useState<ProductCode[]>(defaultProducts);
  const consultationCountryCodes = [CountryCode.GB, CountryCode.US];

  useEffect(() => {
    updateCrossSellProducts();
  }, [cartItems, country]);

  const isExcludedProduct = (product: ProductCode, item: CartItem) => item.productCode?.includes(product);

  const shouldAddConsultation = (item: CartItem) =>
    [ProductCode.STIScreening, ProductCode.VMSEssential, ProductCode.VMSAdvanced].includes(item.productCode) &&
    consultationCountryCodes.includes(country);

  const filterProducts = (products: ProductCode[]) => {
    const filteredByCountryAndLocation = filterProductsByCountry(products, country);

    return filteredByCountryAndLocation.filter((product) => {
      return !cartItems.some((item) => isExcludedProduct(product, item));
    });
  };
  const addConsultationToTopIfNeeded = (products: ProductCode[]) => {
    const needsConsultation = cartItems.some(shouldAddConsultation);
    const hasConsultation = cartItems.some((item) => item.productCode === ProductCode.ConsultationSexualHealth);
    if (needsConsultation && !hasConsultation) {
      return [ProductCode.ConsultationSexualHealth, ...products];
    }
    return products;
  };

  const updateCrossSellProducts = () => {
    let updatedProducts = filterProducts(defaultProducts);
    updatedProducts = addConsultationToTopIfNeeded(updatedProducts);
    setCrossSellProducts(updatedProducts);
  };

  if (crossSellProducts.length === 0) {
    return null;
  }

  const products = crossSellProducts.slice(0, maxItemsToShow);

  return (
    <CartCrossSellContainer>
      <FadeIn duration={400}>
        <CartSectionHeading titleKey="components.cart-cross-sells" isSubscription={false} />
        {products.map((product: any) => (
          <CartCrossSellRow key={product} productCode={product} />
        ))}
      </FadeIn>
    </CartCrossSellContainer>
  );
};

export default CartCrossSells;

const CartCrossSellContainer = styled.div`
  padding: 30px 60px 10px 0;
  width: 100%;
  border-top: 1px solid #faead6;

  @media (max-width: 768px) {
    padding: 30px 30px 10px;
  }
`;
